/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateAgentRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createAgentRequest: components.CreateAgentRequest;
};

/** @internal */
export const CreateAgentRequest$inboundSchema: z.ZodType<
  CreateAgentRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  CreateAgentRequest: components.CreateAgentRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreateAgentRequest": "createAgentRequest",
  });
});
/** @internal */
export type CreateAgentRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  CreateAgentRequest: components.CreateAgentRequest$Outbound;
};

/** @internal */
export const CreateAgentRequest$outboundSchema: z.ZodType<
  CreateAgentRequest$Outbound,
  z.ZodTypeDef,
  CreateAgentRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  createAgentRequest: components.CreateAgentRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    createAgentRequest: "CreateAgentRequest",
  });
});

export function createAgentRequestToJSON(
  createAgentRequest: CreateAgentRequest,
): string {
  return JSON.stringify(
    CreateAgentRequest$outboundSchema.parse(createAgentRequest),
  );
}
export function createAgentRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateAgentRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateAgentRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateAgentRequest' from JSON`,
  );
}
